<template>
  <div class="form-section">
    <div class="form-section-header" v-if="title || $slots.actions">
      <p class="form-section-title text-white" v-if="title">{{ title }}</p>
      <div class="form-section-actions" v-if="$slots.actions">
        <slot name="actions" />
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'form-section',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
.form-section {
  margin-bottom: 1.5rem;
  padding: 1.25rem;
  background: rgba(128, 128, 128, 0.05);
  border-radius: 0.375rem;
  border-left: 3px solid #e14eca;
}

.form-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
  gap: 0.75rem;
}

.form-section-title {
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0;
}

.form-section-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

@media (max-width: 575.98px) {
  .form-section {
    padding: 1rem;
  }
}
</style>

<style lang="scss">
/* Light mode overrides, matching CollapsibleSection */
.white-content .form-section {
  background: rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

  .form-section-title {
    color: #344675;
  }
}
</style>

<style>
.white-content .form-section {
  background: rgba(0, 0, 0, 0.03);
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  border-right: 1px solid rgba(0, 0, 0, 0.06);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

</style>
